import React from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import {
  List as SimpleList,
  ListItem as ListContainer,
  Container,
  Label,
  TextBox
} from '../../../../../components/list';
import { withDisplayCondition } from '../../../../../helpers/hocs/with-display-condition';
import { withHistory } from '../../../../../components/with-history';
import { sendStatus } from '../../../../../store/reducers/status-data';
import { SubTitle } from './components/sub-title';

const ListItemComponent = React.memo(({ item, onClick }) => (
  <ListContainer>
    <Container onClick={onClick} withIcon>
      <TextBox>
        <Label>{item.title}</Label>
        <SubTitle subTitle={item.subTitle} />
      </TextBox>
    </Container>
  </ListContainer>
));

const ListItem = compose(
  withDisplayCondition,
  connect(null, { sendStatus }),
  withHistory,
  withHandlers({
    onClick:
      ({ item, history, sendStatus }) =>
      async () => {
        const { statusData, to } = item;

        if (statusData) {
          const { activityKey, activityStatusKey } = statusData;

          await sendStatus(activityKey, activityStatusKey);
        }

        history.push(to);
      }
  })
)(ListItemComponent);

export const List = React.memo(({ items }) => (
  <SimpleList>
    {items.map(item => (
      <ListItem key={item.title} item={item} displayCondition={item.displayCondition} />
    ))}
  </SimpleList>
));
